import * as Yup from 'yup';

export const verifySignUpOtpSchema = Yup.object().shape({
  otp: Yup.string()
    .length(6, 'OTP must be exactly 6 digits')
    .matches(/^\d{6}$/, 'OTP must be exactly 6 digits')
    .required('OTP is required'),
});

export type VerifySignUpOtpDataType = Yup.InferType<
  typeof verifySignUpOtpSchema
>;

export type InitialValues = {
  otp: String;
};

export const verifySignUpOtpInitialValues: InitialValues = {
  otp: '',
};

export interface IVerifySignUpOtpData {
  email: string;
  otp: string;
}
